// extracted by mini-css-extract-plugin
export default {"hot_box":"index_hot_box_FPW2f","hot_spots":"index_hot_spots_GWVuW","hot_spotsButton":"index_hot_spotsButton_hvas7"};